<template>
  <b-container>
    <div v-if="buildings.length > 0 && teamsGroup.length > 0">
      <b-row class="mt-4">
        <b-col sm="4">
          <b-form-select
            v-model="building"
            :options="buildings"
            v-on:change="OnBuildingClick"
          ></b-form-select>
          <div
            class="text-danger"
            v-if="!$v.building.required && $v.building.$dirty"
          >
            {{ $t("info.required") }}
          </div>
        </b-col>
      </b-row>

      <b-row v-if="building" class="mt-4">
        <b-col>
          <b-alert show variant="info">
            <p class="pt-2">
              <strong>{{ $t("label.currentGroup") }} : </strong
              >{{
                existingTeamBuilding
                  ? existingTeamBuilding.GroupName
                  : $t("label.noAssociation")
              }}
            </p>
            <b-form-group v-if="building.Language" label="Language" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="radio-group-2"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                v-model="building.Language"
              >
                <b-form-radio
                  :aria-describedby="ariaDescribedby"
                  name="french"
                  value="fr"
                  >{{ $t("label.french") }}</b-form-radio
                >
                <b-form-radio
                  :aria-describedby="ariaDescribedby"
                  name="english"
                  value="en"
                  >{{ $t("label.english") }}</b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
            <div v-if="existingTeamBuilding">
              <b-button
                variant="outline-danger"
                @click="removeAssociation()"
                >{{ $t("action.remove") }}</b-button
              >
              <b-button
                class="ml-2"
                variant="outline-info"
                @click="updateGroupInformation()"
                >{{ $t("action.update") }}</b-button
              >
            </div>
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="teamSelect" class="mt-4">
        <b-col>
          <b-alert show variant="info">
            <p>
              <strong>{{ $t("label.newGroup") }}</strong>
            </p>
            <ul>
              <li v-if="buildingMatch">
                <strong>{{ $t("info.groupAlreadyExist") }}</strong>
                {{ teamSelect.displayName }}
              </li>
              <li v-else>
                {{ teamSelect.displayName }}
              </li>
            </ul>

            <b-button
              v-if="!buildingMatch"
              variant="outline-info"
              @click="associateGroupToBuilding()"
              >{{ $t("action.update") }}</b-button
            >
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="groupAssociateToOtherBuilding">
        <b-col>
          <b-alert show variant="danger">
            <p>
              {{ $t("info.existingTeamForBuilding") }}
            </p>
          </b-alert>
        </b-col>
      </b-row>

      <div v-if="building">
        <b-row class="pt-2">
          <b-col sm="4" class="mt-2">
            <b-form-select v-model="perPage" :options="options"></b-form-select>
          </b-col>
          <b-col sm="4" class="mt-2">
            <b-form-input
              v-model="search"
              :placeholder="$t('action.search')"
            ></b-form-input>
            <b-button variant="link" @click="resetTable()">{{
              $t("action.reset")
            }}</b-button>
          </b-col>
          <b-col sm="4" class="mt-2">
            <div>{{ $t("label.tablesize") }} {{ rows }}</div>
          </b-col>
        </b-row>

        <b-row class="pt-4">
          <b-col class="lgTable">
            <b-table
              id="groupTable"
              stacked="lg"
              bordered
              :fields="myfields"
              :items="items"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(details)="row">
                <b-button
                  :variant="row.item.variant"
                  class="ml-2"
                  size="sm"
                  @click="chooseGroup(row.item)"
                  >{{ $t("action.choose") }}</b-button
                >
              </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row class="pt-4">
          <b-col sm="6" class="mt-2">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="groupTable"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-if="spinner" class="text-center">
      <b-spinner
        style="width: 3rem; height: 3rem"
        class="spinner"
        variant="success"
        label="Spinning"
        disabled="labelStatus"
      ></b-spinner>
    </div>

    <div v-if="success" class="pt-4">
      <b-alert show variant="success">
        <p>{{ $t("info.successgeneric") }}</p>
      </b-alert>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  mixins: [globalF],
  props: [],
  data() {
    return {
      success: false,
      immeuble: [],
      error: "",
      spinner: false,
      disabled: false,
      rawData: [],
      teamsGroup: [],
      buildings: [],
      building: null,
      sortBy: "displayName",
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      search: "",
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      teamSelect: null,
      existingTeamBuilding: null,
      groupAssociateToOtherBuilding: false,
      newGroupName: "",
      teamPlan: null,
      teamBucket: null,
      userBuildingGraph: [],
      buildingMatch: null
    };
  },
  validations() {
    return {
      building: {
        required,
      },
    };
  },
  mounted() {
    let accessToken = this.getGlobalData("accessToken");
    //let graphEndpoint = `https://graph.microsoft.com/v1.0/groups?$filter=resourceProvisioningOptions/Any(x:x eq 'Team')`;
    let graphEndpoint = `https://graph.microsoft.com/v1.0/groups`;
    this.getGroupsWithTeams(graphEndpoint, accessToken);
  },
  computed: {
    url: function () {
      return this.getUrl();
    },
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.teamsGroup;
      let search = this.search.toLowerCase();
      return mydatalist.filter((p) => {
        let displayName = p.displayName ? p.displayName : "";
        let email = p.mail ? p.mail : "";
        let createdDateTime = p.createdDateTime ? p.createdDateTime : "";

        return (
          displayName.toString().toLowerCase().includes(search) ||
          email.toString().toLowerCase().includes(search) ||
          createdDateTime.toLowerCase().includes(search)
        );
      });
    },
    myfields: function () {
      return [
        {
          key: "displayName",
          sortable: true,
          label: this.$t("label.nameOfTheGroup"),
        },
        { key: "mail", sortable: true, label: this.$t("label.email") },
        {
          key: "createdDateTime",
          sortable: true,
          label: this.$t("label.date"),
          formatter: (value) => {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
        { key: "details", label: this.$t("label.edit") },
      ];
    },
  },
  methods: {
    getBuildingList() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getAllGroups" },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            //this.immeuble = response.data.immeuble;
            //let buildings = this.mapBuildingForSelect();
            this.teamsBuilding = response.data.teamBuildings;
            let buildings = this.setProvinceAndLanguage(
              response.data.buildings,
              response.data.immeuble,
              response.data.teamBuildings
            );
            this.buildings = this.mapBuildingForBootstrapSelect(buildings);
            
            this.formatRawData();
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    mapBuildingForBootstrapSelect(buildings) {
      let mapBuilding = buildings.map((b) => {
        return {
          text: b.NOMDIV,
          value: b,
        };
      });

      mapBuilding.sort(function (a, b) {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }
        return 0;
      });

      mapBuilding.unshift({
        text: this.$t("label.properties"),
        value: null,
      });

      return mapBuilding;
    },
    setProvinceAndLanguage(buildings, immeubles, groupBuildings) {
      return buildings.map((b) => {
        b.Language = "fr";
        b.Province = "QC";
        let groupBuilding = groupBuildings.find((g) => g.IdBuilding === b.Id);
        if (groupBuilding) {
          b.Language = groupBuilding.Language;
          b.Province = groupBuilding.Province;
        }
        else {
          let immeuble = immeubles.find((i) => i.IdBuilding === b.Id);
          if (immeuble) {
            b.Language = this.getDefaultLg(immeuble);
            b.Province = immeuble.Province;
          }
        }
        return b;
      });
    },
    getDefaultLg(immeuble) {
      let lg = "en";
      if (immeuble) {
        let prov = immeuble.Province;
        prov.replace(/[\W_]+/g, " ");
        if (
          prov.toLowerCase() === "québec" ||
          prov.toLowerCase() === "qc" ||
          prov.toLowerCase() === "quebec"
        ) {
          lg = "fr";
        }
      }
      return lg;
    },
    resetTable: function () {
      this.search = "";
    },
    getGroupsWithTeams(graphEndpoint, token) {
      this.error = "";
      this.spinner = true;

      axios
        .get(graphEndpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            let nextLink = response.data["@odata.nextLink"];
            this.rawData.push(response.data.value);

            if (nextLink) {
              this.getGroupsWithTeams(nextLink, token);
            } else {
              this.getBuildingList();
            }
          } else {
            this.error = this.$t("info.errorgeneric");
          }
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    formatRawData: function () {
      let flatTable = this.rawData.flat(); //Distribution List
      let teamsBuilding = this.teamsBuilding;
      let filterTable = flatTable.filter((f) => {
        return !teamsBuilding.find((t) => t.TeamId === f.id);
      });

      this.teamsGroup = filterTable.map((f) => {
        f.variant = "outline-success";
        return f;
      });
    },
    OnBuildingClick: function () {
      this.error = "";
      this.success = false;
      this.groupAssociateToOtherBuilding = false;
      this.existingTeamBuilding = null;
      this.getGroupAssociatedToBuilding();
    },
    getGroupAssociatedToBuilding() {
      this.existingTeamBuilding = this.teamsBuilding.find(
        (t) => t.IdBuilding === this.building.Id
      );
    },
    chooseGroup: function (group) {
      let tableInfo = this.teamsGroup;
      let teamSelect = this.teamSelect;
      let groupToAssign = null;

      this.teamsGroup = tableInfo.map((g) => {
        if (teamSelect) {
          if (g.id === teamSelect.id) {
            g.variant = "outline-success";
            groupToAssign = null;
          } else {
            if (g.id === group.id) {
              g.variant = "success";
              groupToAssign = group;
            } else {
              g.variant = "outline-success";
            }
          }
        } else {
          if (g.id === group.id) {
            g.variant = "success";
            groupToAssign = group;
          } else {
            g.variant = "outline-success";
          }
        }

        return g;
      });

      this.teamSelect = groupToAssign;
      this.buildingMatch = null;

      if (this.teamSelect) {
        this.buildingMatch = this.teamsBuilding.find(
          (t) =>
            t.GroupId === this.teamSelect.id &&
            t.IdBuilding === this.building.Id
        );
      }
    },
    associateGroupToBuilding: function () {
      this.spinner = true;

      let obj = {
        request: "updateTeam",
        idBuilding: this.building.Id,
        province: this.building.Province,
        language: this.building.Language,
        teamId: this.teamSelect.id,
        teamName: this.teamSelect.displayName,
      };

      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.spinner = false;
          if (response.data === "ExistingTeamForBuilding") {
            this.groupAssociateToOtherBuilding = true;
          } else {
            this.success = true;
            this.resetField();
            this.getBuildingList();
          }
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    refreshGlobalData: function () {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      axios
        .post(
          url,
          { request: "getGlobalData" },
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.$store.commit("addGlobalData", response.data);
          this.buildings = this.mapBuildingForSelect();
          this.resetField();
          this.success = true;
          this.spinner = false;
        })
        .catch(() => {
          this.error = this.$t("info.errorgeneric");
          this.disabled = false;
        });
    },
    resetField() {
      this.search = "";
      this.building = null;
      this.groupAssociateToOtherBuilding = false;
      this.existingTeamBuilding = null;
      this.teamSelect = null;
      let tableInfo = this.teamsGroup;
      this.teamsGroup = tableInfo.map((f) => {
        f.variant = "outline-success";
        return f;
      });
    },
    updateGroupInformation() {
      this.error = "";
      this.spinner = true;

      let obj = {
        request: "updateGroupInformation",
        id: this.existingTeamBuilding.Id,
        idBuilding: this.building.Id,
        province: this.building.Province,
        language: this.building.Language,
      };

      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.success = true;
          this.spinner = false;
          this.resetField();
          this.getBuildingList();
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    removeAssociation() {
      this.error = "";
      this.spinner = true;

      let obj = {
        request: "removeAssociation",
        id: this.existingTeamBuilding.Id,
      };

      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.success = true;
          this.spinner = false;
          this.resetField();
          this.getBuildingList();
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
};
</script>
